export const uploadStarted = (payload) => ({
  type: 'app/UPLOAD_STARTED',
  payload,
});
